import { Image } from "@src/components/Image";
import React from "react";

function BottomNotication({ children, backgroundColor, icon, textColor, marginTop="0px" }) {
  return (
    <div
      className="BottomNotification"
      style={{ backgroundColor: backgroundColor, marginTop: marginTop }}
    >
      {icon ? <img src={icon} height={"16"} width={"16"} /> : ""}
      <span style={{ marginLeft: "8px", color: textColor }}>{children}</span>
    </div>
  );
}

export default BottomNotication;
